export const WISHLIST_QUERY_KEY = () => ['wishlist'];